import { render, staticRenderFns } from "./CanhBaoHangNgayList.vue?vue&type=template&id=105384bb&"
import script from "./CanhBaoHangNgayList.vue?vue&type=script&lang=js&"
export * from "./CanhBaoHangNgayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports